class QuickBuy extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('[data-quick-buy-btn]');
    this.buttonText = this.querySelector('[data-quick-buy-btn] span');
    this.buttonLoader = this.querySelector('.loading-overlay__spinner');
    this.cartItems = document.querySelector('cart-items');
    this.fostrVariantRadios = this.querySelector('fostr-variant-radios');
    this.variantIds = this.getAttribute('variant-ids');
    this.properties = this.getAttribute('line-item-props');
    this.error = this.querySelector('.product-quickbuy__error-message-wrapper');
    this.errorMessageText = this.querySelector('.product-quickbuy__error-message');
    this.allowedValues = ['color', 'colour'];
    this.colourName = this.querySelector('.product-connections .form__label span');
    this.colourGroup = this.querySelector('other-colours');
    this.quickBuyClose = this.querySelector('.quickbuy__close');
    this.gridCollection = document.getElementById('ProductGridContainer');
    this.flyOut = '';
    this.cartItemTotalsEl = document.querySelector('.site-header-cart--count');
    this.cartItemTotalsNum = parseInt(this.cartItemTotalsEl.dataset.headerCartCount);

    if (isNaN(this.cartItemTotalsNum) || this.cartItemTotalsNum == null){
      this.cartItemTotalsNum = 0;
    }

    // KSD cart flyout

    this.header = document.querySelector('[data-site-header]');
    this.atcTemplate = document.querySelector('[data-atc-banner]');


    if (this.fostrVariantRadios) {

      this.mobileTrigger = document.querySelector(
        `[data-trigger="quickbuyitem-${this.fostrVariantRadios.dataset.section}"]`
      );
  
      this.mobileTarget = document.querySelector(
        `[data-target="quickbuyitem-${this.fostrVariantRadios.dataset.section}"]`
      );
    
    }


    if (!this.button) {
      return;
    }

    this.button.addEventListener('click', this.onClickHandler.bind(this));
    this.addEventListener('change', this.onVariantChange.bind(this));

    if (this.mobileTrigger) {
      this.mobileTrigger.addEventListener('click', this.onClickHandlerMobileTrigger.bind(this));
    }

    if (this.mobileTrigger) {
      this.quickBuyClose.addEventListener('click', this.onClickHandlerMobileTrigger.bind(this));
    }
    
    if (this.colourGroup) {
      const colourGroupItems = Array.from(this.colourGroup.querySelectorAll('a.colour'));
      colourGroupItems.forEach(colour => {
        colour.addEventListener('click', this.onClickHandlerGroupColor.bind(this));
      });

    }

  }

  onClickHandlerMobileTrigger() {
    if (window.innerWidth <= 749){
      if (this.gridCollection){
        this.gridCollection.querySelector('.collection').classList.toggle('loading');
      }
      this.mobileTarget.classList.toggle('open');
    }
  }

  onVariantChange() {

    this.classList.add('loading');
    this.querySelector('.loading-overlay.product-loading').classList.remove('hidden');

    this.updateOptions();
    this.updateMasterId();
    this.handleErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateVariantInput();
      this.updateMedia();
      this.renderProductInfo();
    }
  }

  onProductChange() {
    this.updateOptions();
    this.updateMasterId();
    this.handleErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateVariantInput();
      this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.fostrVariantRadios.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
        let colourElement = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
        if(this.allowedValues.includes(colourElement.name.split('-').reverse()[0].toLowerCase())){
            this.colourName.innerHTML = colourElement.value;
        }
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateVariantInput() {
    this.setAttribute('variant-ids', this.currentVariant.id);
    this.variantIds = this.getAttribute('variant-ids');
  }

  getVariantData() {
    this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateMedia(productImage = false) {

    let currentFeature = '';

    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media){  
      if (productImage){  
         currentFeature = productImage;
      }else{
        return
      }
    }else{
      currentFeature = this.currentVariant.featured_media.preview_image.src;
    }

    const imgSizes = ['165', '360', '533', '720', '940', '1066'];
    const format = '.' +  currentFeature.split('.').reverse()[0];
    const itemMedia = document.querySelector(
      `[data-media-id="${this.fostrVariantRadios.dataset.section}"]`
    );

    let srcSizes = '';
    let newFormat = '_'+ imgSizes[2] + 'x' + format;
    let srcImg =  currentFeature.replace(format, newFormat);

    imgSizes.forEach(function(size) {
      let newFormat = '_'+ size + 'x' + format + ' ' + size +'w,';
      let newSize =  currentFeature.replace(format, newFormat)
      srcSizes = srcSizes + newSize;
    })

    itemMedia.src = srcImg;
    itemMedia.srcset = srcSizes;
  }

  renderProductInfo() {
    fetch(`${this.fostrVariantRadios.dataset.url}?variant=${this.currentVariant.id}`)
      .then((response) => response.text())
      .then((responseText) => {

        const html = new DOMParser().parseFromString(responseText, 'text/html')

        const price_id = `.price-${this.fostrVariantRadios.dataset.section}`;
        const price_source = html.querySelector('.price');

        const variantTitle_id = `.variant-${this.fostrVariantRadios.dataset.section}`;
        const variantTitle_source = this.currentVariant.title;

        document.querySelectorAll(price_id).forEach((price_destination) => {
          if (price_source && price_destination){
            price_destination.innerHTML = price_source.innerHTML;
          }
        });

        document.querySelectorAll(variantTitle_id).forEach((variantTitle_destination) => {
          if (variantTitle_source && variantTitle_destination && variantTitle_source != 'Default Title'){
            variantTitle_destination.innerHTML = variantTitle_source;
          }
        })

        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      })
      .finally(() => {
        this.querySelector('.loading-overlay.product-loading').classList.add('hidden');
        //this.classList.remove('loading')
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {

    const addButton = this.button;
    const addButtonText = this.buttonText;

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('aria-disabled', true);
      this.querySelector('.loading-overlay.product-loading').classList.add('hidden');
      //this.classList.remove('loading')
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('aria-disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
    
  }

  setUnavailable() {
    const addButton = this.button;
    const addButtonText = this.buttonText;
    const price = document.querySelector(`price-${this.fostrVariantRadios.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }


  handleErrorMessage(errorMessage = false) {

    this.errorMessageWrapper = this.errorMessageWrapper || this.error;
    this.errorMessage = this.errorMessage || this.errorMessageText;
    if (this.errorMessageWrapper) {
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
    }

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }

  onClickHandler(event) {
    event.preventDefault();

    this.variantIds = this.getAttribute('variant-ids');

    if (!this.variantIds) {
      return;
    }

    this.handleErrorMessage();

    this.button.setAttribute('aria-disabled', true);
    //this.button.classList.add('loading');
    //this.buttonLoader.classList.remove('hidden');

    const quantityEl = this.querySelector('input[name="quantity"]');
    const quantity = (quantityEl) ? parseInt(quantityEl.value) : 1;

    let properties;
    if (this.properties) {
      try {
        properties = JSON.parse(this.properties);
        properties._bundle = properties._bundle + '-' + Math.floor((Math.random() * 1000000) + 1000) + '';
        console.log(properties)
      } catch (err) {
        console.error(err);
      }
    }

    let itemsObj = [];
    const varIdsArr = this.variantIds.split(',');

    varIdsArr.forEach(varId => {
      itemsObj.push({
        id: varId,
        quantity: quantity,
        properties: properties
      });
    });

    let body = {
      items: itemsObj
    };

    if (this.cartItems) {
      body.sections = this.cartItems.getSectionsToRender().map(section => section.id);
      body.sections_url = window.location.pathname;
    }

    body = JSON.stringify(body);

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then(response => response.json())
      .then(response => {

        if (response.status) {
          this.dispatchEvent(
            new CustomEvent(
              'fostr-quick-buy-done',
              { bubbles: true, detail: { status: 'error', info: response } }
            )
          );
          this.handleErrorMessage(response.description);
          return;
        }

        this.dispatchEvent(
          new CustomEvent(
            'fostr-quick-buy-done',
            { bubbles: true, detail: { status: 'success' } }
          )
        );

        this.cartItems?.renderContents(response);

        let properties;
        if (this.properties) {
          try {
            properties = JSON.parse(this.properties);

            this.flyOut = this.atcTemplate.cloneNode(true);
            this.flyOut.setAttribute('data-flyout-active', true);

            var bundleImage = '<img src="' + properties._bundleImage + '">'
            var bundlePrice = window.shopCurrency + (properties._bundleDiscountPrice / 100).toFixed(2);
            var newCartItemTotal = parseInt(this.cartItemTotalsNum) + parseInt(properties._bundleProductAmount);

            this.cartItemTotalsEl.setAttribute('data-header-cart-count', newCartItemTotal) ;
            this.header.appendChild(this.flyOut);

            let flyoutCloseButton = document.querySelector('[data-atc-banner-close]');
            let mainBody = document.querySelector('.site-main');

            flyoutCloseButton.addEventListener("click", function() {
                let closeThisFlyout = document.querySelector('[data-flyout-active]');
                if (closeThisFlyout) {
                  closeThisFlyout.remove();
                }
            });

            mainBody.addEventListener("click", function() {
                let closeThisFlyout = document.querySelector('[data-flyout-active]');
                if (closeThisFlyout) {
                  closeThisFlyout.remove();
                }
            });

            this.flyOut.querySelector('[data-atc-banner-product-title]').innerHTML = properties._bundleTitle;
            this.flyOut.querySelector('[data-atc-banner-product-price-quantity]').innerHTML = '1 ×';
            this.flyOut.querySelector('[data-atc-banner-product-price-value]').innerHTML = bundlePrice;
            this.flyOut.querySelector('[data-atc-banner-product-discounts] .discount-amount').innerHTML = properties._bundleDiscountValue;
            this.flyOut.querySelector('[data-atc-banner-product-image]').innerHTML = bundleImage;
            this.flyOut.querySelector('[data-atc-banner-cart-button] span').innerHTML = newCartItemTotal;

            this.flyOut.querySelector('[data-atc-banner-product-discounts]').classList.add('hidden');

            fetch(`/cart.js`, { ...fetchConfig('javascript'), body })
            .then(response => response.json())
            .then(response => {

              if (response.status) {
                return;
              }

              var cartTotalPrice = window.shopCurrency + (response.total_price / 100).toFixed(2);
              this.flyOut.querySelector('[data-atc-banner-cart-subtotal]').innerHTML = cartTotalPrice;
              
            })
            .catch(error => {
              console.error(error);
            });

          } catch (err) {
          }
        }

        
      })
      .catch(error => {
        this.dispatchEvent(
          new CustomEvent(
            'fostr-quick-buy-done',
            { bubbles: true, detail: { status: 'error', error: error } }
          )
        );
        console.error(error);
      })
      .finally(() => {
        //this.button.classList.remove('loading');
        this.button.removeAttribute('aria-disabled');
        //this.buttonLoader.classList.add('hidden');
        //this.onClickHandlerMobileTrigger();

        // trigger cart
        this.flyOut.classList.add('visible');

      });
  }


  groupProductSetup(event){
    event.preventDefault();

    //this.classList.add('loading');
    this.querySelector('.loading-overlay.product-loading').classList.remove('hidden');
    
    let currentItem = this.colourGroup.querySelector('a.colour.current');
    let newItem = event.target;
    let newItemUrl = event.target.href;

    currentItem.classList.remove('current');
    newItem.classList.add('current');

    this.newDataUrl = this.fostrVariantRadios.getAttribute('data-url');

    if (newItemUrl.includes(this.newDataUrl)){ 
      this.querySelector('.loading-overlay.product-loading').classList.add('hidden');
      //this.classList.remove('loading')
      return
    };
  }

  groupProductSetTitle(html, event){
    const title = `.title-${this.fostrVariantRadios.dataset.section}`;
    const titleSource = html.querySelector('.product__title');
    document.querySelectorAll(title).forEach((titleDestination) => {
      if (titleSource && titleDestination){ 
        titleDestination.innerHTML = titleSource.innerHTML;
        titleDestination.setAttribute('href', event.target.href);
      };
    });

  }

  groupProductSetVariantTitle(html, event){
    const variantTitle_id = `.variant-${this.fostrVariantRadios.dataset.section}`;
    const variantTitle_source = this.currentVariant.title;
    document.querySelectorAll(variantTitle_id).forEach((variantTitle_destination) => {
      if (variantTitle_source && variantTitle_destination && variantTitle_source != 'Default Title'){
        variantTitle_destination.innerHTML = variantTitle_source;
      }
    })
  }

  groupProductSetPrice(html){
    const price = `.price-${this.fostrVariantRadios.dataset.section}`;
    const priceSource = html.querySelector('.price');

    document.querySelectorAll(price).forEach((priceDestination) => {
      if (priceSource && priceDestination){ 
        priceDestination.innerHTML = priceSource.innerHTML
        priceDestination.classList.remove('visibility-hidden');
      };
    });

  }

  groupProductSetColour(html){
    const colour = `.colour-${this.fostrVariantRadios.dataset.section}`;
    const colourSource = html.querySelector('.colour_label');
    document.querySelectorAll(colour).forEach((colourDestination) => {
      if (colourSource && colourDestination) colourDestination.innerHTML = colourSource.innerHTML;
    });

  }


  groupProductSetVariantData(html, event){
    const variantIDSource = html.querySelector('.product-form input[type="hidden"][name="id"]');
    this.fostrVariantRadios.setAttribute('data-url', event.target.href);
    if (variantIDSource){ 
      this.setAttribute('variant-ids', variantIDSource.getAttribute('value'));
      this.variantIds = this.getAttribute('variant-ids');
    };
  }

  groupProductSetOptions(html){
    const variantOptionsDestination = this.fostrVariantRadios;
      const variantOptionsSource = html.querySelector('fostr-variant-radios');
      if (variantOptionsSource && variantOptionsDestination){ 
        variantOptionsDestination.innerHTML = variantOptionsSource.innerHTML;
      };
  }

  groupProductSetMedia(html){
    this.mediaData = JSON.parse(html.querySelector('#product-image-data[type="application/json"]').textContent);
    if (this.mediaData){ 
      this.updateMedia(this.mediaData.src);
    };
  }


  onClickHandlerGroupColor(event) {
    this.groupProductSetup(event);
    fetch(`${event.target.href}`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      this.groupProductSetTitle(html, event);
      this.groupProductSetPrice(html);
      this.groupProductSetColour(html);
      this.groupProductSetVariantData(html, event);
      this.groupProductSetOptions(html);
      this.onProductChange();
      this.groupProductSetMedia(html);
      this.groupProductSetVariantTitle(html);
    })
    .finally(() => {
      this.querySelector('.loading-overlay.product-loading').classList.add('hidden');
      //this.classList.remove('loading')
    });
  }

}  

customElements.define('quick-buy', QuickBuy);


class QuickBuySelects extends QuickBuy {
  constructor() {
    super();
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
        return this.options[0].toString() === variant.id.toString();
    });
  }

  groupProductSetOptions(html){
    const variantOptionsDestination = this.fostrVariantRadios.querySelector('.product-form__input--dropdown');
    const variantOptionsSource = html.querySelector('.quickbuy-dropdown-source');
    if (variantOptionsSource && variantOptionsDestination){ 
      const variantOptionsSourceFormLabel =  variantOptionsSource.querySelector('label.form__label');
      variantOptionsSourceFormLabel.classList.add('hidden');
      variantOptionsDestination.innerHTML = variantOptionsSource.innerHTML;
    };
  }

  groupProductSetVariantData(html, event){
    this.fostrVariantRadios.setAttribute('data-url', event.target.href);
    const variantIDSource = html.querySelector('.product-form input[type="hidden"][name="id"]');
    if (variantIDSource){ 
      this.setAttribute('variant-ids', variantIDSource.getAttribute('value'));
      this.variantIds = this.getAttribute('variant-ids');
    };
    
    const variantJsonSource = html.querySelector('fostr-variant-radios [type="application/json"]');
    const variantJsonDestination = this.fostrVariantRadios.querySelector('[type="application/json"]');
    if (variantJsonSource && variantJsonDestination){ 
      variantJsonDestination.textContent = variantJsonSource.textContent;
    };

  }

}

customElements.define('quick-buy-selects', QuickBuySelects);
